import type { Components, Theme } from '@mui/material/styles';

import { paper, varAlpha } from '../../styles';

// ----------------------------------------------------------------------

const MuiDrawer: Components<Theme>['MuiDrawer'] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    paperAnchorRight: ({ ownerState, theme }) => ({
      ...(ownerState.variant === 'temporary' && {
        ...paper({ theme }),
        boxShadow:
          theme.palette.mode === 'dark'
            ? `-40px 40px 80px -8px ${varAlpha(
                theme.palette.common.blackChannel,
                0.24
              )}`
            : `-40px 40px 80px -8px ${varAlpha(
                theme.palette.grey['500Channel'],
                0.24
              )}`,
      }),
    }),
    paperAnchorLeft: ({ ownerState, theme }) => ({
      ...(ownerState.variant === 'temporary' && {
        ...paper({ theme }),
        boxShadow:
          theme.palette.mode === 'dark'
            ? `40px 40px 80px -8px  ${varAlpha(
                theme.palette.common.blackChannel,
                0.24
              )}`
            : `40px 40px 80px -8px ${varAlpha(
                theme.palette.grey['500Channel'],
                0.24
              )}`,
      }),
    }),
  },
};

// ----------------------------------------------------------------------

export const drawer = { MuiDrawer };
